import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { APP_NAME } from "constants/app.constant";

const LOGO_SRC_PATH = "/img/logo/";

const Logo = (props) => {
  const { type, mode, gutter, className, imgClass, style, logoWidth } = props;
  const domain = window.location.host.slice(
    0,
    window.location.host.indexOf(".")
  );
  const isVarta = domain.includes("varta");

  return (
    <div
      className={classNames("logo", className, gutter)}
      style={{
        ...style,
        ...{ width: logoWidth },
      }}
    >
      {isVarta ? (
        <div className="flex justify-center">
          <img
            className={classNames(
              imgClass,
              `${type === "full" ? "!w-72" : ""} max-w-none mx-auto`
            )}
            src={`${LOGO_SRC_PATH}varta-logo-${type}.png`}
            alt={`${APP_NAME} logo`}
          />
        </div>
      ) : (
        <img
          className={imgClass}
          src={`${LOGO_SRC_PATH}logo-light-${type}.${
            type === "full" ? "png" : "svg"
          }`}
          alt={`${APP_NAME} logo`}
        />
      )}
    </div>
  );
};

Logo.defaultProps = {
  mode: "light",
  type: "full",
  logoWidth: "auto",
};

Logo.propTypes = {
  mode: PropTypes.oneOf(["light", "dark"]),
  type: PropTypes.oneOf(["full", "streamline"]),
  gutter: PropTypes.string,
  imgClass: PropTypes.string,
  logoWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default Logo;
